
<template>
  <div
    class="single-menu"
    :class="[size]"
  >
    <ul>
      <li
        class="single-menu__item"
        v-for="(item, i) in data"
        :key="i"
        :class="{ active: curIndex == i }"
        @click="handleChooseItem(item, i)"
      >
        <slot
          name="icon"
          :item="item"
        />
        <span class="single-menu__text">{{ item[label] }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import { watch, reactive, toRefs } from 'vue';
export default {
  name: 'TmSingleMenu',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: 'name',
    },
    size: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      curIndex: props.index || 0,
    });

    watch(
      () => props.index,
      (newVal) => {
        state.curIndex = newVal;
      }
    );

    function handleChooseItem(item, index) {
      state.curIndex = index;
      emit('callback', item);
    }
    return {
      ...toRefs(state),
      handleChooseItem,
    };
  },
};
</script>
<style lang="less" scoped>
.single-menu {
  &.small {
    .single-menu__item {
      line-height: 26px;
    }
    .single-menu__text {
      font-weight: normal;
    }
    :deep(.iconfont) {
      font-size: 12px;
    }
  }
  &__item {
    margin-bottom: 3px;
    padding-left: 10px;
    line-height: 30px;
    font-size: 14px;
    font-weight: 500;
    color: @navFontColor;
    cursor: pointer;
    &.active {
      background: @activeBgColor;
      border-radius: 4px;
      color: @navFontActiveColor;
      :deep(.iconfont) {
        color: @navFontActiveColor;
      }
    }
    &:hover {
      opacity: 0.8;
    }
  }
  &__text {
    margin-left: 8px;
  }
  :deep(.iconfont) {
    font-weight: normal;
  }
  :deep(.img-icon) {
    width: 16px;
    height: 16.8px;
  }
}
</style>
